// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as RestApi$DvmAdminFrontendFr from "../../../api/RestApi.bs.js";
import * as Bonuses_Manage_Types$DvmAdminFrontendFr from "./Bonuses_Manage_Types.bs.js";
import * as Messages_Bonuses_Manage$DvmAdminFrontendFr from "../../../intl/messages/bonuses/Messages_Bonuses_Manage.bs.js";

function changeBonus(userManager, setResult, bonuses, operation, intl, selectedRole, requestType) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  var typeStr;
  switch (requestType) {
    case /* PERF */0 :
        typeStr = "perf";
        break;
    case /* POOL */1 :
        typeStr = "pool";
        break;
    case /* PSER */2 :
        typeStr = "pser";
        break;
    
  }
  var tmp;
  switch (operation) {
    case /* Validate */0 :
        tmp = "/bonuses/manual/" + typeStr + "/status?newStatus=VALIDATED";
        break;
    case /* Refuse */1 :
        tmp = "/bonuses/manual/" + typeStr + "/status?newStatus=REFUSED";
        break;
    case /* ToValidate */2 :
        tmp = "/bonuses/manual/" + typeStr + "/status?newStatus=TOVALIDATE";
        break;
    case /* ChangeAmount */3 :
        tmp = "/bonuses/manual/amount";
        break;
    
  }
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("PUT", {
          TAG: /* Json */0,
          _0: requestType !== 1 ? Bonuses_Manage_Types$DvmAdminFrontendFr.editedBonusList_encode(bonuses) : Bonuses_Manage_Types$DvmAdminFrontendFr.editedBonus_encode(Belt_Option.getWithDefault(Belt_List.get(bonuses, 0), {
                      actionID: "",
                      orderID: "",
                      editedAmount: undefined,
                      refuseReason: undefined,
                      approved: undefined
                    }))
        }, userManager, selectedRole, tmp).then(function (result) {
        if (result.TAG === /* OkResult */0) {
          return Curry._1(setResult, (function (param) {
                        var tmp;
                        switch (operation) {
                          case /* Validate */0 :
                              tmp = Messages_Bonuses_Manage$DvmAdminFrontendFr.validateSuccess;
                              break;
                          case /* Refuse */1 :
                              tmp = Messages_Bonuses_Manage$DvmAdminFrontendFr.refusedSuccess;
                              break;
                          case /* ToValidate */2 :
                              tmp = Messages_Bonuses_Manage$DvmAdminFrontendFr.backToValidateSuccess;
                              break;
                          case /* ChangeAmount */3 :
                              tmp = Messages_Bonuses_Manage$DvmAdminFrontendFr.amountChangeSuccess;
                              break;
                          
                        }
                        return {
                                TAG: /* Ok */0,
                                _0: intl.formatMessage(tmp)
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function derogateCall(userManager, setResult, intl, selectedRole, orderId, actionId, requestType) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  var typeStr;
  switch (requestType) {
    case /* PERF */0 :
        typeStr = "perf";
        break;
    case /* POOL */1 :
        typeStr = "pool";
        break;
    case /* PSER */2 :
        typeStr = "pser";
        break;
    
  }
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("POST", undefined, userManager, selectedRole, "/bonuses/manual/" + typeStr + "/bypass?orderId=" + orderId + "&actionId=" + actionId + "").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: intl.formatMessage(Messages_Bonuses_Manage$DvmAdminFrontendFr.derogationSuccess)
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function changeBonusAmount(userManager, setResult, bonuses, intl, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("PUT", {
          TAG: /* Json */0,
          _0: Bonuses_Manage_Types$DvmAdminFrontendFr.editedBonus_encode(bonuses)
        }, userManager, selectedRole, "/bonuses/manual/amount").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: intl.formatMessage(Messages_Bonuses_Manage$DvmAdminFrontendFr.amountChangeSuccess)
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

export {
  changeBonus ,
  derogateCall ,
  changeBonusAmount ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
